import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IItemProps {
  $isMobile: boolean;
}

export const Wrapper = styled.div<IItemProps>`
  width: 100%;
  position: fixed;
  top: 0;
  ${({ $isMobile }) => !$isMobile && ('min-height: 10vh;')}
  z-index: 8;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background-image: linear-gradient(180deg,rgba(35,35,35,0.71) 1.04%,rgb(255 255 255 / 99%) 100%);
  backdrop-filter: blur(8px);
  border-radius: 0px 0px 10px 15px;
  box-shadow: 0 30px 40px rgba(0,0,0,.1);
`

export const Container = styled.div<IItemProps>`
  max-width: 95vw;
  width: ${({ $isMobile }) => $isMobile ? '100%' : '70%'} ;
  padding: 14px 51px;
  
  position: relative;

  display: flex;
  flex-direction: row;
  align-items:  ${({ $isMobile }) => $isMobile ? 'flex-start' : 'center'};
  justify-content: space-between;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: none;
  }
`

export const ContainerMobile = styled.div<any>`
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 8vh;
  padding: 0 3%;
  max-height: 8vh;
  overflow: hidden;
  margin: 5px 0 20px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: flex;
  }
`

export const TitleWrapper = styled.div``

export const Title = styled.h1`
  // margin-top: 0.05vh;
  font-size: clamp(1rem, 2vw, 3rem);;
  // line-height: 48px;
  text-align: center;
  color: #FFFFFF;
  `

export const EquipName = styled.div`
  font-weight: bold;
  font-size: ${customTheme.fontSizes.md};
  line-height: 27px;
  text-align: center;  
  color: ${({ color }) => color || customTheme.colors.white};

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-weight: normal;
    padding: 5px;
    
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;

    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
`

export const Menu = styled.div`
  border-radius: 35px;

  position: relative;
  overflow: hidden;
  z-index: 99;
  
  transition: background-color 0.3s;

  & > div:first-child {
    border: 5px solid #606373;
    background: #A8AAB3;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);;
    & > section {
      opacity: 1;
    }
  }

  & > section {
    opacity: 0;

    transition: opacity 0.3s;
  }

`

export const MenuItem = styled.div`
  width: 56px;
  height: 56px;
  
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  cursor: pointer;
`

export const MenuImg = styled.img`
`

export const SideWrapper = styled.div`
  flex: 1;
  
`

export const PointsWrapper = styled.div`
  height: 56px;
  padding-right: 80px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const Points = styled.span`
  margin-left: 18px;

  display: flex;
  align-items: center;

  font-weight: bold;
  font-size: 95%;  
  color: ${({ color }) => color || customTheme.colors.white};

  @media (max-width: ${customTheme.breakpoints[1]}) {
    margin-left: 8px;
  }
`

export const Icon = styled.img`
  height: 35px;
  width: 35px;

  object-fit: contain;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 25px;
    width: 25px
  }
`

export const LogoContainer = styled.div`
  width: 25%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  >img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  svg {
    color: ${({ color }) => color || customTheme.colors.white};
    font-size: 45px;
  }
`
export const LogoContainerDesktop = styled.div`
  width: 25%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  svg {
    color: ${({ color }) => color || customTheme.colors.white};
    font-size: 45px;
  }
`

export const PointsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 25%;
  max-width: 25%;
`
